/*
* Project: LegalPlace assistant
* File: src/logic/preview_render/condition_manager.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

let staticExceptionList = [];

export function initializeEList() {
  staticExceptionList = [];
}

export function pushEList(id) {
  let _ = false;
  staticExceptionList.forEach((idx) => {
    if (idx === id) _ = true;
  });
  if (!_) staticExceptionList.push(id);
  window.cond_s = staticExceptionList;
}



// WEBPACK FOOTER //
// ./src/logic/preview_render/condition_manager.js